import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const fetchSiteSettings = async () => {
    try {
      const response = await axios.get(`${API}/site/settings`);
      setSite(response.data);
    } catch (error) {
      console.error('Failed to fetch site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const flags = site?.featureFlags || {};
  const interactiveMode = flags.interactiveMode || 'donation_only';
  const amazonBuyLink = flags.amazonBuyLink || 'https://amazon.com';
  const donationLink = flags.donationLink || '';
  const interactiveCtaLabel = flags.interactiveCtaLabel || 'Read Interactive';

  return (
    <SiteContext.Provider value={{
      site,
      loading,
      interactiveMode,
      amazonBuyLink,
      donationLink,
      interactiveCtaLabel,
      isInteractiveLive: interactiveMode === 'interactive_live',
      refreshSite: fetchSiteSettings
    }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};
